import { useState } from 'react';

export const useConfirmDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({
    title: '',
    description: '',
    onConfirm: () => {},
  });

  const openDialog = (
    title: string,
    description: string,
    onConfirm: () => void,
  ) => {
    setConfig({ title, description, onConfirm });
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    config,
    openDialog,
    closeDialog,
  };
};
